import Menu from './Menu';
import type { TMenuItem } from './Menu.types';

export { Menu, type TMenuItem };
